"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullableObjectLikeValue = exports.isValidObjectValue = exports.isObjectWithKeysValue = exports.isObjectLikeValue = void 0;
const isObjectLikeValue = (fieldValue) => {
    return (fieldValue != null &&
        typeof fieldValue === "object" &&
        !Array.isArray(fieldValue));
};
exports.isObjectLikeValue = isObjectLikeValue;
const isObjectWithKeysValue = (fieldValue, keysToCompare, passThrough = false) => {
    if (!(0, exports.isObjectLikeValue)(fieldValue))
        return false;
    if (passThrough)
        return true;
    const keys = Object.keys(fieldValue);
    if (keys.length === 0)
        return false;
    return keys.every((key) => keysToCompare.find((property) => property === key));
};
exports.isObjectWithKeysValue = isObjectWithKeysValue;
const isValidObjectValue = (fieldValue, typeCheckObject, passThrough = false) => {
    if (!(0, exports.isObjectLikeValue)(fieldValue))
        return false;
    const objectProperties = Object.keys(typeCheckObject);
    if (!(0, exports.isObjectWithKeysValue)(fieldValue, objectProperties, passThrough))
        return false;
    return objectProperties.every((key) => {
        const isPropertyValid = typeCheckObject[key];
        const valueToCheck = fieldValue[key];
        return isPropertyValid(valueToCheck);
    });
};
exports.isValidObjectValue = isValidObjectValue;
const isNullableObjectLikeValue = (fieldValue) => {
    return fieldValue === null || (0, exports.isObjectLikeValue)(fieldValue);
};
exports.isNullableObjectLikeValue = isNullableObjectLikeValue;
